import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { PROCESS_STEPS } from '../../lib/site';
import { SectionHeading } from '../ui/SectionHeading';
export function ProcessSection() {
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start 65%', 'end 55%']
  });
  const lineWidth = useTransform(scrollYProgress, [0, 1], ['0%', '100%']);
  const dropletX = useTransform(scrollYProgress, [0, 1], ['0%', '100%']);
  return <section className="relative bg-mist py-24" data-id="element-280" data-mp="2gzue7myuyirw">
      <div className="mx-auto max-w-7xl px-6" data-id="element-281" data-mp="2gyjafn5exb0s">
        <SectionHeading eyebrow="Our Process" title="A Seamless Path From Damage to Dream" subtitle="Five carefully orchestrated steps — transparent, fast, and built around your peace of mind." data-id="element-282" data-mp="2lsnjqd25hv51" />

        <div ref={ref} className="relative mt-20" data-id="element-283" data-mp="2vnp6x3cv8n4z">
          {/* animated water line (desktop) */}
          <div className="absolute left-0 right-0 top-8 hidden h-1 rounded-full bg-royal/10 lg:block" data-id="element-284" data-mp="30msdwtcep3fl">
            <motion.div className="relative h-full rounded-full bg-gradient-to-r from-electric to-royal" style={{
            width: lineWidth
          }} data-id="element-285" data-mp="3qlosmwb8cass" />
            <motion.div className="absolute -top-2 h-5 w-5 -translate-x-1/2 rounded-full bg-electric shadow-[0_0_16px_rgba(45,168,255,0.9)]" style={{
            left: dropletX
          }} data-id="element-286" data-mp="3grez3bajx6gh" />
          </div>

          <div className="grid gap-8 lg:grid-cols-5" data-id="element-287" data-mp="8b3ejdnbgcgy">
            {PROCESS_STEPS.map((step, i) => <motion.div key={step.title} initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.7,
            delay: i * 0.12,
            ease: [0.22, 1, 0.36, 1]
          }} className="relative" data-id="element-288" data-mp="3hr0tyk6dq2z" data-mpi={i}>
                <div className="relative z-10 mx-auto lg:mx-0 flex h-16 w-16 items-center justify-center rounded-2xl bg-white font-display text-xl font-bold text-royal shadow-glow ring-4 ring-mist" data-id="element-289" data-mp="2bpngg6unrh8z">
                  {String(i + 1).padStart(2, '0')}
                </div>
                <div className="glass-strong mt-6 rounded-3xl p-6 shadow-glass" data-id="element-290" data-mp="27pmu801bi1rd">
                  <h3 className="font-display text-base font-bold text-navy" data-id="element-291" data-mp="1sruhffn5nrgv">
                    {step.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate" data-id="element-292" data-mp="1xryxx5o2cm73">
                    {step.text}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}